import util from './shared/util.js';
import config from '../config.js';

var servicesURL = `${config.server.url}:${config.server.webServicesPort}/primary-skill/`;

class cdoPrimarySkill {
    selectAll = (callback) => {
        util.getJSON(servicesURL + 'select-all', callback);
    }
}

const cdo = new cdoPrimarySkill();
export default cdo;
